import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'object_id': {
    title: '销售订单号',
    type: 'input',
    equation: all
  },
  'process_type': {
    describe: true,
    title: '销售订单类型',
    type: 'select',
    equation: city,
    dictionary: 'A0043'
  },
  'status': {
    describe: true,
    title: '状态',
    type: 'select',
    equation: city,
    dictionary: 'A0033'
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    },
    unSearchRole: 'WLY001'
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    unSearchRole: 'WLY001'
  },
  'customer_type': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009',
    unSearchRole: 'WLY001'
  },
  'bill_to': {
    title: '开票客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '开票客户编号'
    }
  },
  'bitll_name': {
    title: '开票客户名称',
    type: 'input',
    equation: cusname
  },
  'inv_type': {
    describe: true,
    title: '发票类型',
    type: 'select',
    equation: city,
    dictionary: 'A0032'
  },
  'use_quantity': {
    title: '本次开票数量',
    // slot: true,
    // columnParams: { bgEdit: true }
  },
  'use_zzfld9': {
    title: '本次开票件数',
    slot: true,
    columnParams: { bgEdit: true }
  },
  'use_bot': {
    title: '本次开票瓶数',
    slot: true,
    columnParams: { bgEdit: true }
  },
  'warehouse': {
    title: '仓库',
    slot: true,
    columnParams: { bgEdit: true }
  },
  'quantity': {
    title: '订单数量'
  },
  'zzfld000009': {
    title: '订单件数'
  },
  'order_bot': {
    title: '订单瓶数'
  },
  'zzfld000001': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'zzfld00002q': {
    describe: true,
    title: '计划类型',
    type: 'select',
    equation: all,
    dictionary: 'A0002'
  },
  'ordered_prod': {
    title: '产品编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '产品编码'
    }
  },
  'description': {
    title: '产品描述',
    type: 'input',
    equation: cusname
  },
  'zzfld00002s': {
    title: '规格',
    type: 'input',
    equation: cusname
  },
  'zzfld00002t': {
    title: '单位',
    type: 'input',
    equation: cusname
  },
  'zzfld00002o': {
    title: '占用开票数量'
  },
  'zzfld000035': {
    title: '占用开票件数'
  },
  'zy_bill_bot': {
    title: '占用开票瓶数'
  },
  'zzfld000007': {
    title: '累计开票数量'
  },
  'zzfld000032': {
    title: '累计开票件数'
  },
  'lj_bill_bot': {
    title: '累计开票瓶数'
  },
  'remain_quantity': {
    title: '剩余开票数量'
  },
  'remain_zzfld9': {
    title: '剩余开票件数'
  },
  'remain_bot': {
    title: '剩余开票瓶数'
  },
  'use_value': {
    title: '本次开票价税合计',
    width: 140
  },
  'use_zzfld2i': {
    title: '本次开票折扣额',
    width: 140
  },
  'zzfld00002e': {
    title: '税率'
  },
  'net_price': {
    title: '含税单价'
  },
  'net_value': {
    title: '订单价税合计'
  },
  'zzfld00002a': {
    describe: true,
    title: '折扣类型',
    type: 'select',
    equation: all,
    dictionary: 'A0037'
  },
  'zzfld00002f': {
    title: '单品折扣'
  },
  'zzfld00002g': {
    title: '折扣含税单价'
  },
  'zzfld000008': {
    title: '明细备注',
    type: 'input',
    equation: cusname
  },
  'zzfld000028': {
    title: '抬头备注',
    type: 'input',
    equation: cusname
  },
  'zzfld00002d_dscr': {
    title: '创建人',
    type: 'input',
    equation: cusname
  },
  'posting_date': {
    title: '创建日期',
    type: 'date',
    equation: all,
    defaultVal: new Date()
  },
  'if_offset': {
    title: '是否拆分行',
    type: 'whether',
    equation: be
  }
}



// WEBPACK FOOTER //
// ./src/views/invoice-manage/config/CheckeOrder.js